<div id="header-container" class="row m-0" >
  <div class="col">
    <button [ngClass]="{ 'no-pointer': isNoPointerRoute() }" (click)="reDirectUrl()" class="geotherm-logo-button">
      <img class="geotherm-logo" alt="geotherm-logo" src="../../../../assets/images/geotherm-logo.svg" />
    </button>
  </div>

  @if (showMsHeader && userAccount?.name) {
    <div class="no-print col menu-container">
      <div class="demo-section">
        <mat-icon class="home-icon" (click)="reDirectUrl()">
          <img alt="geotherm-logo" src="../../../../assets/icons/Home-1.svg" />
        </mat-icon>
        <mat-icon
          class="cursor"
          [matMenuTriggerFor]="notificationmenu"
          [matBadge]="unreadNotificationCount > 10 ? '10+' : unreadNotificationCount"
          [matBadgeHidden]="unreadNotificationCount <= 0"
          matBadgeColor="warn">
          <img class="img-position" alt="geotherm-logo" src="../../../../assets/icons/Union.svg" />
        </mat-icon>
      </div>
      <mat-menu #notificationmenu="matMenu" class="notification-menu">
        @if (notifications.length > 0) {
          <div class="max-height-70">
            @for (notification of notifications; track notification) {
              <div class="notification-sub">
                <span class="notification-title">
                  {{ notification.message }}
                </span>
                @if (!notification.isRead) {
                  <button class="dismiss-btn" (click)="onNotificationDismiss(notification)">
                    DONE
                  </button>
                }
              </div>
            }
          </div>
        }
        @if (notifications.length === 0) {
          <span class="notification-title"> No notifications found. </span>
        }
      </mat-menu>
      <div class="demo-section1 cursor" [matMenuTriggerFor]="usermenu">
        <mat-icon>
          <img class="img-position" src="../../../../assets/icons/profile.svg" alt="profile-icon" />
        </mat-icon>
        <span class="text"> {{ userAccount.name }}</span>
      </div>
      <mat-menu #usermenu="matMenu" class="notification-menu user-menu">
        @if (userService.roleCheck(['Admin'])) {
          <div class="button-hover">
            <button mat-button (click)="settings()">
              <span class="user-text">
                <img src="/assets/icons/settings-user.svg" alt="settings-user" />&nbsp; Settings
              </span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin', 'Reportwriter', 'Manager']) && !isMobile) {
          <div class="button-hover">
            <button mat-button (click)="navigateToGeoXplore()">
              <span class="user-text"> <img src="/assets/icons/globe.svg" alt="globe"  />&nbsp; GeoXplore </span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin', 'Reportwriter', 'Manager']) && !isMobile) {
          <div class="button-hover">
            <button mat-button (click)="navigateToGeoXplorePrecast()">
              <span class="user-text"> <img src="/assets/icons/globe.svg" alt="globe"  />&nbsp; GeoXplore - Mix Designs </span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin']) && !isMobile) {
          <div class="button-hover">
            <button mat-button (click)="navigateToAuditLogReport()">
              <span class="user-text"> <img src="/assets/icons/union_audit.svg" alt="audit-log" width="16px" />&nbsp; Audit Log Report</span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin']) && !isMobile) {
          <div class="button-hover">
            <button mat-button (click)="navigateToAnalyzeTr()">
              <span class="user-text"> <img src="/assets/icons/union_audit.svg" alt="analyze-tr" width="16px" />&nbsp; Analyze TRs</span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin','Manager']) && !isMobile) {
          <div class="button-hover">
            <button mat-button (click)="navigateToInHouseDashborad()">
              <span class="user-text"> <img src="/assets/icons/Dashboard.svg" alt="in-house-dashboard" width="19px" />&nbsp;{{ buttonText }}</span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin', 'Manager', 'Reportwriter']) && !isMobile) {
          <div class="button-hover">
            <button mat-button (click)="mixDesign()">
              <span class="user-text"> <img src="/assets/icons/mix-design-bowl.svg" alt="mix-design-dashboard" style="width: 20px; height: 20px; vertical-align: middle;"/>&nbsp; Mix Design Dashboard</span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin'])) {
          <div class="button-hover">
            <button mat-button (click)="management()">
              <span class="user-text"> <img src="/assets/icons/user_management.svg" alt="Customers" />&nbsp; Access Management </span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin'])) {
          <div class="button-hover">
            <button mat-button (click)="companyManagement()">
              <span class="user-text"> <img src="/assets/icons/company_management.svg" alt="Customers" />&nbsp; Companies </span>
            </button>
          </div>
        }
        @if (userService.roleCheck(['Admin', 'Manager'])) {
          <div class="button-hover">
            <button mat-button (click)="disposeSamples()">
              <span class="user-text"> <img src="/assets/icons/dispose_samples.svg" alt="Dispose Samples" />&nbsp; Dispose Samples </span>
            </button>
          </div>
        }
        <div class="button-hover">
          <button mat-button (click)="logOut()">
            <span class="user-text"> <img src="/assets/icons/logout.svg" alt="logout" />&nbsp; Log Out </span>
          </button>
        </div>
      </mat-menu>
    </div>
  }

  @if ((customerAuthService.getJwtLoggedInSubject() | async) && userDetailsFetched) {
    <div class="no-print col menu-container">
      <div class="demo-section1 cursor" [matMenuTriggerFor]="usermenu" >
        <mat-icon>
          <img class="img-position" src="../../../../assets/icons/profile.svg" alt="profile-icon" />
        </mat-icon>
        <span class="text"> {{ contactName$ | async}}</span>
      </div>
      <mat-menu #usermenu="matMenu" class="notification-menu user-menu">
        <div  class="button-hover" >
          <button mat-button (click)="profile()">
            <span class="user-text">
              <img src="/assets/icons/settings-user.svg" alt="settings-user" />&nbsp; Edit Profile
            </span>
          </button>
        </div>
        <div class="button-hover">
          <button mat-button (click)="cLogOut()">
            <span class="user-text"> <img src="/assets/icons/logout.svg" alt="logout" />&nbsp; Log Out </span>
          </button>
        </div>
      </mat-menu>
    </div>
  }

</div>
